<template>
  <v-breadcrumbs class="crumbs px-0 py-1" :items="items">
    <template #divider>
      <v-icon size="16" class="crumbs__divider">mdi-chevron-right</v-icon>
    </template>
    <template #item="{ item }">
      <v-breadcrumbs-item
        :href="item.href"
        :disabled="item.disabled"
        class="crumbs__item"
      >
        {{ item.text }}
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>
<script>
export default {
  name: "BreadCrumb",
  props: {
    items: Array,
    default: () => []
  }
};
</script>
<style scoped>
.crumbs {
  font-size: 13px;
}
.crumbs__divider {
  color: var(--muted-foreground);
}
.crumbs >>> .crumbs__item {
  color: var(--muted-foreground);
  font-weight: 500;
}
.crumbs >>> a.crumbs__item {
  color: var(--signal);
}
.crumbs >>> .v-breadcrumbs__item--disabled {
  color: var(--foreground);
}
</style>
